import React from 'react'; 
import ModPageHeader from './ModPageHeader';
import ModText from './ModText';
import ModLinkGrid from './ModLinkGrid';
import ModImageGrid from './ModImageGrid';
import ModProducts from './ModProducts';
import ModImage from './ModImage';
import ModVideo from './ModVideo';
import ModTeam from './ModTeam';
import ModImageTextCols from './ModImageTextCols';
import ModLogos from './ModLogos';
import ModDesigners from './ModDesigners';
import ModPullout from './ModPullout';
import ModInstagram from './ModInstagram';
import ModProjectGallery from './ModProjectGallery';
import ModFabrics from './ModFabrics';
import ModCollections from './ModCollections';
import ModAccordions from './ModAccordions';
import WithConsumer from '../context/WithConsumer';


const PageBlock = ({index,context}) => {
 
    const posts = () => context.posts;
    const post = posts()[0];
    const block = post.block[index]; 

    let content = '';
    
    if (block) {
	    	    	   
	    if (block.type == 'page-header') {
		    content = <ModPageHeader block={block}></ModPageHeader>
	    } else if (block.type == 'text') {
		    content = <ModText block={block}></ModText>
		} else if (block.type == 'linkgrid') {
		    content = <ModLinkGrid block={block}></ModLinkGrid>
		} else if (block.type == 'products') {
		    content = <ModProducts block={block}></ModProducts>
		} else if (block.type == 'imagegrid') {
		    content = <ModImageGrid block={block}></ModImageGrid>
	    } else if (block.type == 'image') {
		    content = <ModImage block={block}></ModImage>
	    } else if (block.type == 'video') {
		    content = <ModVideo block={block}></ModVideo>
		} else if (block.type == 'team') {
		    content = <ModTeam block={block}></ModTeam>
		} else if (block.type == 'imagetextcols') {
		    content = <ModImageTextCols block={block}></ModImageTextCols>
		} else if (block.type == 'logos') {
		    content = <ModLogos block={block}></ModLogos>
	    } else if (block.type == 'designers') {
		    content = <ModDesigners block={block}></ModDesigners>
	    } else if (block.type == 'pullout') {
		    content = <ModPullout block={block}></ModPullout>
	    } else if (block.type == 'instagram') {
		    content = <ModInstagram block={block}></ModInstagram>
		} else if (block.type == 'fabrics') {
		    content = <ModFabrics block={block}></ModFabrics>
	    } else if (block.type == 'project_gallery') {
		    content = <ModProjectGallery block={block}></ModProjectGallery>
	    } else if (block.type == 'collections') {
		    content = <ModCollections block={block}></ModCollections>
	    } else if (block.type == 'accordions') {
		    content = <ModAccordions block={block}></ModAccordions>
	    }
    
    }

    return content;

};
export default WithConsumer(PageBlock);